import { B2Tabs } from "@hdb/biome-2";
import { useQuery } from "@tanstack/react-query";
import { CSSProperties, FC, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { generateFilenameWithTimestamp } from "src/shared/helpers/generateFilenameWithTimestamp";
import {
  getassetDisplayLevelAndLocationsByBlock
} from "src/store/slices/dashboard.slice";
import { getBaselineListByModuleId } from "../../../../../core/api/services/baseline.service";
import {
  getMotionTrafficDataByBlockCodeWithLevelOrLocation
} from "../../../../../core/api/services/dashbaorad-details/motion-traffic.service";
import {
  AssetDisplayLevelChartType,
  MotionTrafficChartType,
} from "../../../../../core/enums/dashboard-enums";
import CustomHighChartComponent from "../../../../../shared/custom-highchart-component/custom-highchart.component";
import CustomStackedChartCcomponent from "../../../../../shared/custom-highchart-component/custom-stacked-chart.component";
import CustomSpinnerComponent from "../../../../../shared/custom-spinner/custom-spinner.component";
import "../dashboard-details.component.scss";
import TabularFilterComponent from "../extra-components/tabular.filter.component";

interface MotionTrafficChartTypes {
  blockCode: any;
  isRefreshed: boolean;
}

const MotionTrafficChart: FC<MotionTrafficChartTypes> = ({
  blockCode,
  isRefreshed,
}) => {
  const dispatch = useDispatch();

  // const assetDisplayLevelsByBlock = useSelector(
  //   (state: any) => state.dashboard.assetDisplayLevelsByBlock
  // );

  const [switchMotionTrafficChartView, setSwitchMotionTrafficChartView] =
    useState<number>(MotionTrafficChartType.Motion_Count_Vs_Time);

  const [motionCountVsTimeData, setMotionCountVsTimeData] = useState<{
    yAxisMotionCount: [];
    xAxisValues: [];
  }>({ yAxisMotionCount: [], xAxisValues: [] });

  const [motionCountVsSensorData, setMotionCountVsSensorData] = useState<{
    yAxisMotionCount: [];
    xAxisValues: [];
    extraData: [];
  }>({ yAxisMotionCount: [], xAxisValues: [], extraData: [] });

  const [motionCountVsLevelData, setMotionCountVsLevelData] = useState<{
    seriesData: [];
    xAxisValues: [];
  }>({ seriesData: [], xAxisValues: [] });

  const [motionCountVsLocationData, setMotionCountVsLocationData] = useState<{
    seriesData: [];
    xAxisValues: [];
  }>({ seriesData: [], xAxisValues: [] });

  const [selectedLocation, setSelectedLocation] = useState(null);
  const [activeKey, setActiveKey] = useState("Time");
  const [render, setRender] = useState(0);

  // Old API call to fetch motion traffic data
  // const { data: motionTrafficData, isLoading: isLoadingMotionTrafficData } =
  //   useQuery({
  //     queryKey: [
  //       "getMotionTrafficData",
  //       blockCode,
  //       switchMotionTrafficChartView,
  //       selectedLocation,
  //     ],
  //     queryFn: ({ signal }) =>
  //       getMotionTrafficData(
  //         blockCode,
  //         switchMotionTrafficChartView,
  //         switchMotionTrafficChartView ===
  //           MotionTrafficChartType.Motion_Count_Vs_Sensor ||
  //           switchMotionTrafficChartView ===
  //             MotionTrafficChartType.Motion_Count_Vs_Time
  //           ? selectedLocation
  //           : null,
  //         signal
  //       ),
  //     enabled: !!blockCode || isRefreshed,
  //   });

  // New API call to fetch motion traffic data with level or location
  const { data: motionTrafficData, isLoading: isLoadingMotionTrafficData } =
    useQuery({
      queryKey: [
        "getMotionTrafficDataByBlockCodeWithLevelOrLocation",
        blockCode,
        switchMotionTrafficChartView,
        selectedLocation,
      ],
      queryFn: ({ signal }) => {
        const location =
          switchMotionTrafficChartView ===
            MotionTrafficChartType.Motion_Count_Vs_Sensor ||
            switchMotionTrafficChartView ===
            MotionTrafficChartType.Motion_Count_Vs_Time
            ? selectedLocation
            : null;
        const locationType =
          switchMotionTrafficChartView ===
            MotionTrafficChartType.Motion_Count_Vs_Sensor ||
            switchMotionTrafficChartView ===
            MotionTrafficChartType.Motion_Count_Vs_Time
            ? assetDisplayLevelsByBlock?.find(
              (item: any) => item.DisplayLevel === selectedLocation
            )?.Type
            : null;
        return getMotionTrafficDataByBlockCodeWithLevelOrLocation(
          blockCode,
          switchMotionTrafficChartView,
          location,
          locationType,
          signal
        );
      },
      enabled: !!blockCode || isRefreshed,
    });

  useEffect(() => {
    if (
      motionTrafficData?.data?.length ||
      motionTrafficData?.data?.assetDisplayLevels?.length ||
      motionTrafficData?.data?.assetDisplayLocations?.length
    ) {
      let yAxisMotionCount;
      let xAxisValues;

      if (
        switchMotionTrafficChartView ===
        MotionTrafficChartType.Motion_Count_Vs_Time
      ) {
        /*         const filteredData = motionTrafficData?.data?.filter(
          (item: any) => item?.motionCount > 0
        );

        if (filteredData?.length <= 0) {
          setMotionCountVsTimeData({
            yAxisMotionCount: [],
            xAxisValues: [],
          });
        } else { */
        xAxisValues = motionTrafficData.data.map((d: any) => d.hour);

        yAxisMotionCount = motionTrafficData.data.every(
          (d: any) => d?.motionCount == null
        )
          ? null
          : motionTrafficData.data.map((d: any) => d?.motionCount);

        setMotionCountVsTimeData({
          yAxisMotionCount,
          xAxisValues,
        });
        // }
      } else if (
        switchMotionTrafficChartView ===
        MotionTrafficChartType.Motion_Count_Vs_Sensor
      ) {
        //  original solution
        const xAxisValues = motionTrafficData?.data?.map(
          (d: any) => d?.sensorDisplayName
        );

        const yAxisMotionCount = motionTrafficData?.data?.map(
          (d: any) => d?.motionCount
        );

        const extraData = motionTrafficData?.data?.map((data: any) => {
          return {
            code: data?.assetCode,
            displayName: data?.sensorDisplayName,
            location: data?.assetDisplayLocation,
            level: data?.location,
          };
        });

        setMotionCountVsSensorData({
          yAxisMotionCount,
          xAxisValues,
          extraData,
        });

        // temporary solution
        /* const filteredData = motionTrafficData?.data?.filter(
          (item: any) => item?.motionCount != null
        );

        const xAxisValues = filteredData.map((d: any) => d.sensorDisplayName);

        const yAxisMotionCount = filteredData.every(
          (d: any) => d?.motionCount == null
        )
          ? null
          : filteredData.map((d: any) => d?.motionCount);

        const extraData = filteredData.map((data: any) => {
          return {
            code: data?.assetCode,
            displayName: data?.sensorDisplayName,
            location: data?.assetDisplayLocation,
          };
        });

        setMotionCountVsSensorData({
          yAxisMotionCount,
          xAxisValues,
          extraData,
        }); */
      } else if (
        switchMotionTrafficChartView ===
        MotionTrafficChartType.Motion_Count_Vs_LEVEL
      ) {
        // original solution
        /*         xAxisValues = motionTrafficData?.data?.assetDisplayLevels;

        const seriesData =
          motionTrafficData?.data?.assetDisplayLocationMotion?.map((d: any) => {
            return {
              name: d?.secondaryLocation,
              data: d?.motionDatas,
            };
          });

        setMotionCountVsLevelData({ seriesData, xAxisValues }); */

        // Temporary solution

        const { assetDisplayLevels, assetDisplayLocationMotion } =
          motionTrafficData?.data || {};

        /*         const areAllMotionDatasZero = assetDisplayLocationMotion?.every(
          (item: any) => item?.motionDatas?.every((value: any) => value === 0)
        );

        if (areAllMotionDatasZero) {
          setMotionCountVsLevelData({ seriesData: [], xAxisValues: [] });
        } else { */
        // Determine the indices of assetDisplayLevels to keep
        const indicesToKeep = assetDisplayLevels.map((_: any, index: any) =>
          assetDisplayLocationMotion.some(
            (locationMotion: any) => locationMotion.motionDatas[index] != null
          )
        );

        // Filter the assetDisplayLevels and motionDatas based on the indices to keep
        const filteredAssetDisplayLevels = assetDisplayLevels.filter(
          (_: any, index: any) => indicesToKeep[index]
        );

        const filteredAssetDisplayLocationMotion =
          assetDisplayLocationMotion.map((locationMotion: any) => ({
            ...locationMotion,
            motionDatas: locationMotion.motionDatas.filter(
              (_: any, index: any) => indicesToKeep[index]
            ),
          }));

        // Update xAxisValues and seriesData
        const xAxisValues = filteredAssetDisplayLevels;

        const seriesData = filteredAssetDisplayLocationMotion.every(
          (d: any) => d?.secondaryLocation == null || d?.motionDatas == null
        )
          ? null
          : filteredAssetDisplayLocationMotion.map((d: any) => ({
            name: d?.secondaryLocation,
            data: d?.motionDatas,
          }));

        // const seriesData = filteredAssetDisplayLocationMotion.map((d: any) => ({
        //   name: d.secondaryLocation,
        //   data: d.motionDatas,
        // }));

        // Set the updated data
        setMotionCountVsLevelData({ seriesData, xAxisValues });
        // }
      } else {
        // original solution
        /*         xAxisValues = motionTrafficData?.data?.assetDisplayLocations;

        const seriesData =
          motionTrafficData?.data?.assetDisplayLevelMotion?.map((d: any) => {
            return {
              name: d?.secondaryLocation,
              data: d?.motionDatas,
            };
          });

        setMotionCountVsLocationData({ seriesData, xAxisValues }); */

        // temprary solution to hide the location with total zero motion count

        // Process and refactor the data
        const { assetDisplayLocations, assetDisplayLevelMotion } =
          motionTrafficData?.data || {};

        /*         const areAllMotionDatasZero = assetDisplayLevelMotion?.every(
          (item: any) => item?.motionDatas?.every((value: any) => value === 0)
        );

        if (areAllMotionDatasZero) {
          setMotionCountVsLocationData({ seriesData: [], xAxisValues: [] });
        } else { */
        // Determine the indices of assetDisplayLocations to keep
        const indicesToKeep = assetDisplayLocations.map((_: any, index: any) =>
          assetDisplayLevelMotion.some(
            (levelMotion: any) => levelMotion.motionDatas[index] != null
          )
        );

        // Filter the assetDisplayLocations and motionDatas based on the indices to keep
        const filteredAssetDisplayLocations = assetDisplayLocations.filter(
          (_: any, index: any) => indicesToKeep[index]
        );

        const filteredAssetDisplayLevelMotion = assetDisplayLevelMotion.map(
          (levelMotion: any) => ({
            ...levelMotion,
            motionDatas: levelMotion.motionDatas.filter(
              (_: any, index: any) => indicesToKeep[index]
            ),
          })
        );

        // Update xAxisValues and seriesData
        const xAxisValues = filteredAssetDisplayLocations;

        const seriesData = filteredAssetDisplayLevelMotion.every(
          (d: any) => d?.secondaryLocation == null || d?.motionDatas == null
        )
          ? null
          : filteredAssetDisplayLevelMotion.map((d: any) => ({
            name: d?.secondaryLocation,
            data: d?.motionDatas,
          }));

        // const seriesData = filteredAssetDisplayLevelMotion.map((d: any) => ({
        //   name: d.secondaryLocation,
        //   data: d.motionDatas,
        // }));

        // Set the updated data
        setMotionCountVsLocationData({ seriesData, xAxisValues });
        // }
      }
    }
  }, [motionTrafficData]);

  // MT chart
  const [
    motionTrafficVsTimeBaselineValues,
    setMotionTrafficVsTimeBaselineValues,
  ] = useState<any>({});

  const [
    motionTrafficVsLocationBaselineValues,
    setMotionTrafficVsLocationBaselineValues,
  ] = useState<any>({});
  const [assetDisplayLevelsByBlock, setAssetDisplayLevelsByBlock] =
    useState<any>(null);

  const [
    motionTrafficVsSensorBaselineValues,
    setMotionTrafficVsSensorBaselineValues,
  ] = useState<any>({});

  const { data: motionTrafficListByModule } = useQuery({
    queryKey: ["getBaselineListByModuleId", 2, blockCode],
    queryFn: () =>
      getBaselineListByModuleId({
        baselineModuleId: 2,
        blockCode: blockCode,
        assetCode: null,
      }),
  });

  const calculateChartbaselineTime = (startTime: string, endTime: string) => {
    // let singaporeTime = 14;
    const singaporeTime = Number.parseInt(
      new Date().toLocaleTimeString("en-US", {
        timeZone: "Asia/Singapore",
        hour12: false,
      })
    );

    let chartStartTimeHour: number =
      (Number.parseInt(startTime) + 24 - singaporeTime) % 24;
    let chartEndTimeHour: number =
      (Number.parseInt(endTime) + 24 - singaporeTime) % 24;

    let chartStartTimeMin: number = Number.parseFloat(startTime?.split(":")[1]) / 60;
    let chartEndTimeMin: number = Number.parseFloat(endTime?.split(":")[1]) / 60;

    let times = [];

    //

    let totalStartTime = chartStartTimeHour + chartStartTimeMin;
    let totalEndTime = chartEndTimeHour + chartEndTimeMin;

    let extraStartTime = 0;
    let extraEndTime = 0;

    // let newStartTime = 0;
    // let newEndTime = 0;

    if (totalStartTime < 23.5) {
      // newStartTime = totalStartTime;
    } else {
      // newStartTime = 23.5;
      extraStartTime = totalStartTime - 23.5;
    }

    if (totalEndTime < 23.5) {
      // newEndTime = totalEndTime;
    } else {
      // newEndTime = 23.5;
      extraEndTime = totalEndTime - 23.5;
    }

    if (
      (totalStartTime >= 23 && totalStartTime <= 24) ||
      (totalEndTime >= 23 && totalEndTime <= 24)
    ) {
      if (extraStartTime != 0 && extraEndTime != 0 && totalEndTime != 0) {
        times.push(
          [totalStartTime, 23.5],
          [-0.5, -0.5 + extraEndTime],
        );
      } else if (
        extraStartTime != 0 &&
        extraEndTime == 0 &&
        totalEndTime != 0
      ) {
        times.push([-0.5 + extraStartTime, totalEndTime]);
      } else if (
        extraStartTime == 0 &&
        extraEndTime != 0 &&
        totalEndTime != 0
      ) {
        times.push(
          [totalStartTime, 23.5],
          [-0.5, -0.5 + extraEndTime],
        );
      } else if (
        extraStartTime == 0 &&
        extraEndTime == 0 &&
        totalEndTime != 0
      ) {
        if (totalStartTime >= totalEndTime) {
          times.push([totalStartTime, 23.5], [-0.5, totalEndTime]);
        } else {
          times.push([totalStartTime, totalEndTime]);
        }
      }

      if (totalEndTime == 0) {
        if (extraStartTime != 0) {
          times.push([-0.5 + extraStartTime, 0.000000001]);
        } else {
          times.push(
            [totalStartTime, 23.5], // 23
            [-0.5 + extraStartTime, 0.000000001],
          );
        }
      }
    } else {
      if (totalEndTime == 0) {
        if (extraStartTime != 0) {
          times.push([-0.5 + extraStartTime, 0.000000001]);
        } else {
          times.push(
            [totalStartTime, 23.5], // 23
            [-0.5 + extraStartTime, 0.000000001],
          );
        }
      } else {
        if (totalStartTime >= totalEndTime) {
          times.push(
            [chartStartTimeHour + chartStartTimeMin, 23.5],
            [-0.5, chartEndTimeHour + chartEndTimeMin],
          );
        } else {
          times.push([
            (chartStartTimeHour == 0 ? 0.000000001 : chartStartTimeHour) +
            chartStartTimeMin,
            chartEndTimeHour + chartEndTimeMin,
          ]);
        }
      }
    }

    return times;
  };

  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let motionTrafficTimeRanges: any = [];
    let motionTrafficTime: any = [];

    if (motionTrafficListByModule?.data) {
      setEnabled(motionTrafficListByModule?.data?.isEnabled);
      // Time
      motionTrafficListByModule?.data?.motionVsTime?.map((module: any) => {
        let ranges = calculateChartbaselineTime(
          module.startTime,
          module.endTime
        );

        if (ranges.length > 1) {
          ranges?.map((range) => {
            motionTrafficTime.push(module.motionTimeValue);
            motionTrafficTimeRanges.push(range);
          });
        } else {
          motionTrafficTime.push(module.motionTimeValue);
          motionTrafficTimeRanges.push(...ranges);
        }
      });

      setMotionTrafficVsTimeBaselineValues({
        base: motionTrafficTime,
        ranges: motionTrafficTimeRanges,
      });

      // Location
      let motionTrafficLocation: any = [];

      motionTrafficListByModule?.data?.motionVsLocation?.map((module: any) => {
        motionTrafficLocation.push(module.motionLocationValue);
      });

      setMotionTrafficVsLocationBaselineValues({
        base: motionTrafficLocation,
        ranges: [],
      });

      // Sensor
      let motionTrafficSensor: any = [];

      motionTrafficListByModule?.data?.motionVsSensor?.map((module: any) => {
        motionTrafficSensor.push(module.motionSensorValue);
      });

      setMotionTrafficVsSensorBaselineValues({
        base: motionTrafficSensor,
        ranges: [],
      });
    }
  }, [motionTrafficListByModule]);

  // set chart min/max value (including baseline) on y-axis
  const getMinMax = (yAxisData: any, baselineData: any) => {
    if (yAxisData?.length) {
      let minValue = 0;

      if (baselineData?.length) {
        minValue = Math.min(...yAxisData, ...baselineData) - 5;
      } else {
        minValue = Math.min(...yAxisData) - 5;
      }

      if (minValue < 0) {
        minValue = 0;
      }

      let maxValue = 50;

      if (baselineData?.length) {
        maxValue = Math.max(...yAxisData, ...baselineData) + 5;
      } else {
        maxValue = Math.max(...yAxisData) + 5;
      }

      return { min: minValue, max: maxValue };
    }

    return { min: 0, max: 50 };
  };

  // Time
  const [yAxisMaxTime, setYAxisMaxTime] = useState<number>(50);
  const [yAxisMinTime, setYAxisMinTime] = useState<number>(0);

  useEffect(() => {
    const yAxisData = motionCountVsTimeData?.yAxisMotionCount;
    const baselineData = motionTrafficVsTimeBaselineValues?.base;

    let timeMinMaxValue: any = getMinMax(yAxisData, baselineData);

    setYAxisMinTime(timeMinMaxValue.min);
    setYAxisMaxTime(timeMinMaxValue.max);
  }, [motionCountVsTimeData, motionTrafficVsTimeBaselineValues]);

  // Sensor
  const [yAxisMaxSensor, setYAxisMaxSensor] = useState<number>(50);
  const [yAxisMinSensor, setYAxisMinSensor] = useState<number>(0);

  useEffect(() => {
    const yAxisData = motionCountVsSensorData?.yAxisMotionCount;
    // const baselineData = motionTrafficVsSensorBaselineValues?.base;

    // let sensorMinMaxValue: any = getMinMax(yAxisData, baselineData);

    /*     setYAxisMinSensor(sensorMinMaxValue.min);
    setYAxisMaxSensor(sensorMinMaxValue.max); */

    setYAxisMinSensor(0);
    const max = yAxisData ? Math.max(...yAxisData) + 5 : 5;

    setYAxisMaxSensor(max);
  }, [motionCountVsSensorData, motionTrafficVsSensorBaselineValues]);
  //const [assetDisplayLevelsByBlock, setAssetDisplayLevelsByBlock] = useState <any>(null);

  // Location
  /*   const [yAxisMaxLocation, setYAxisMaxLocation] = useState<number>(50);
  const [yAxisMinLocation, setYAxisMinLocation] = useState<number>(0);

    useEffect(() => {
    
    const baselineData = motionTrafficVsLocationBaselineValues?.base;

    let locationMinMaxValue: any = getMinMax(yAxisData, baselineData);

    setYAxisMinLocation(locationMinMaxValue.min);
    setYAxisMaxLocation(locationMinMaxValue.max);
  }, [motionCountVsLocationData, motionTrafficVsLocationBaselineValues]); */

  useEffect(() => {
    // Old API to fetch asset display levels
    // dispatch(
    //   getAssetDisplayLevelsByBlock({
    //     blockCode,
    //     chartType: AssetDisplayLevelChartType.Motion,
    //   })
    // ).then((response: any) => {
    //   setAssetDisplayLevelsByBlock(response?.payload);
    // });

    // New API to fetch asset display levels and locations
    dispatch(
      getassetDisplayLevelAndLocationsByBlock({
        blockCode,
        chartType: AssetDisplayLevelChartType.Motion,
      })
    ).then((response: any) => {
      setAssetDisplayLevelsByBlock(response?.payload);
    });
  }, [blockCode]);

  useEffect(() => {
    if (activeKey === "Sensor") {
      setSwitchMotionTrafficChartView(
        MotionTrafficChartType.Motion_Count_Vs_Sensor
      );
    } else if (activeKey === "Level") {
      setSwitchMotionTrafficChartView(
        MotionTrafficChartType.Motion_Count_Vs_LEVEL
      );
    } else if (activeKey === "Location") {
      setSwitchMotionTrafficChartView(
        MotionTrafficChartType.Motion_Count_Vs_LOCATION
      );
    } else {
      setSwitchMotionTrafficChartView(
        MotionTrafficChartType.Motion_Count_Vs_Time
      );
    }
    setRender(render + 1);
  }, [activeKey, switchMotionTrafficChartView]);

  const onChangeHandler = (selectedValue: any) => {
    const newValue = selectedValue === "All Level" ? null : selectedValue;

    // If there's no change, exit early
    if (newValue === selectedLocation) return;

    // Reset the data when changing the location
    setMotionCountVsTimeData({
      yAxisMotionCount: [],
      xAxisValues: [],
    });

    setMotionCountVsSensorData({
      yAxisMotionCount: [],
      xAxisValues: [],
      extraData: [],
    });

    setMotionCountVsLevelData({
      seriesData: [],
      xAxisValues: [],
    });

    setMotionCountVsLocationData({
      seriesData: [],
      xAxisValues: [],
    });

    // Update selection
    setSelectedLocation(newValue);
    setRender(render + 1);
  };

  // Responsive placeholder for tabular filter
  const [responsivePlaceholder, setResponsivePlaceholder] = useState(
    window.innerWidth <= 992 ? "Select" : "Select Levels/Locations"
  );

  // Responsive style for tabular filter
  const [tabularFilterStyle, setTabularFilterStyle] = useState<
    CSSProperties | undefined
  >(undefined);

  // Update placeholder and style based on window width
  useEffect(() => {
    const updatePlaceholder = () => {
      if (window.innerWidth <= 992) {
        setResponsivePlaceholder("Select");
        setTabularFilterStyle({
          width: "15%",
          position: "absolute",
          zIndex: "999",
          top: "-50px",
          right: "0",
        });
      } else {
        setResponsivePlaceholder("Select Levels/Locations");
        setTabularFilterStyle({
          width: "22%",
          position: "absolute",
          zIndex: "999",
          top: "-50px",
          right: "0",
        });
      }
    };

    // Set initial placeholder
    updatePlaceholder();

    // Add event listener for window resize
    window.addEventListener("resize", updatePlaceholder);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", updatePlaceholder);
    };
  }, []);

  // Motion Traffic specific tooltip formatter
  const motionTrafficTooltipFormatterForMotionVsSensor = (point: any) => {
    const { x, y } = point;

    const sensorName =
      motionCountVsSensorData?.xAxisValues?.[point.index] ||
      point.category ||
      x;

    // Find location from extraData
    const extraDataItem: any = motionCountVsSensorData?.extraData?.find(
      (data: any) => data?.displayName === sensorName
    );

    const level = extraDataItem?.level || "Unknown";

    const SensorName = `<b>Sensor:</b> ${sensorName}<br />`;
    const MotionCount = `<b>Motion Count:</b> ${y}<br />`;

    const Level = `<b>Level:</b> ${level}<br />`;

    return `${SensorName}${MotionCount}${Level}`;
  };

  const motionTrafficTooltipFormatterForMotionVsTime = (point: any) => {
    const { x, y } = point;

    const time =
      motionCountVsSensorData?.xAxisValues?.[point.index] ||
      point.category ||
      x;

    return `<b>Time (Hour):</b> ${time}<br /><b>Motion Count:</b> ${y}<br />`;
  };

  return (
    <div className="w-lg-48 w-100 mt-4">
      <div className="bg-card tab-parent-mt">
        <div className="d-md-flex">
          <div className="mb-4 mb-md-0">
            <h4 className="h4">
              Motion Traffic{" "}
              <span style={{ fontSize: "16px" }}>(Last Day)</span>
            </h4>
          </div>
        </div>

        <div className="custom_tab motion-traffic-responsive-tabs">
          <B2Tabs
            key={render}
            activeKey={activeKey}
            pills
            onSelect={(selectedId: any) => {
              if (selectedId === "Sensor") {
                setSwitchMotionTrafficChartView(
                  MotionTrafficChartType.Motion_Count_Vs_Sensor
                );
                setSelectedLocation(null);
                setActiveKey("Sensor");
              } else if (selectedId === "Level") {
                setSwitchMotionTrafficChartView(
                  MotionTrafficChartType.Motion_Count_Vs_LEVEL
                );

                setActiveKey("Level");
              } else if (selectedId === "Location") {
                setSwitchMotionTrafficChartView(
                  MotionTrafficChartType.Motion_Count_Vs_LOCATION
                );

                setActiveKey("Location");
              } else {
                setSwitchMotionTrafficChartView(
                  MotionTrafficChartType.Motion_Count_Vs_Time
                );
                setSelectedLocation(null);
                setActiveKey("Time");
              }
            }}
            tab={[
              {
                content: (
                  <CustomSpinnerComponent
                    height={"400px"}
                    width={"100%"}
                    isLoading={isLoadingMotionTrafficData || isRefreshed}
                  >
                    <TabularFilterComponent
                      selectedValue={selectedLocation}
                      options={assetDisplayLevelsByBlock}
                      onChangeHandler={onChangeHandler}
                      placeHolder={responsivePlaceholder}
                      style={tabularFilterStyle}
                    />
                    <CustomHighChartComponent
                      xAxisCategories={motionCountVsTimeData?.xAxisValues}
                      SeriesType={"areaspline"}
                      seriesData={motionCountVsTimeData?.yAxisMotionCount}
                      seriesShowInLegend={false}
                      seriesName={"Motion"}
                      xAxisTitleText={"Time (Hours)"}
                      yAxisTitleText={"Motion Count"}
                      colors={["#66b2ff"]}
                      baseLine={
                        enabled ? motionTrafficVsTimeBaselineValues : {}
                      }
                      yAxisMin={yAxisMinTime}
                      yAxisMax={yAxisMaxTime}
                      fileName={generateFilenameWithTimestamp(
                        "Motion Traffic (Last Day)"
                      )}
                      chartName={"Motion Traffic (Last Day)"}
                      tooltipFormatter={
                        motionTrafficTooltipFormatterForMotionVsTime
                      }
                    />
                  </CustomSpinnerComponent>
                ),
                id: "Time",
                title: "Motion vs Time",
              },
              {
                content: (
                  <CustomSpinnerComponent
                    height={"400px"}
                    width={"100%"}
                    isLoading={isLoadingMotionTrafficData || isRefreshed}
                  >
                    <CustomStackedChartCcomponent
                      xAxisCategories={motionCountVsLevelData?.xAxisValues}
                      SeriesType={"column"}
                      seriesData={motionCountVsLevelData?.seriesData}
                      seriesShowInLegend={false}
                      isShowDataLevels={false}
                      isShowStackedColor={false}
                      seriesName={"Motion"}
                      xAxisTitleText={"Level"}
                      yAxisTitleText={"Motion Count"}
                      baseLine={
                        enabled ? motionTrafficVsLocationBaselineValues : {}
                      }
                      setSelectedLocation={setSelectedLocation}
                      setActiveKey={setActiveKey}
                      fileName={generateFilenameWithTimestamp(
                        "Motion Traffic (Last Day)"
                      )}
                      chartName={"Motion Traffic (Last Day)"}
                      isNavigationActive={true}
                    />
                  </CustomSpinnerComponent>
                ),
                id: "Level",
                title: "Motion vs Level",
              },
              {
                content: (
                  <CustomSpinnerComponent
                    height={"400px"}
                    width={"100%"}
                    isLoading={isLoadingMotionTrafficData || isRefreshed}
                  >
                    <CustomStackedChartCcomponent
                      xAxisCategories={motionCountVsLocationData?.xAxisValues}
                      SeriesType={"column"}
                      seriesData={motionCountVsLocationData?.seriesData}
                      seriesShowInLegend={false}
                      isShowDataLevels={false}
                      isShowStackedColor={false}
                      seriesName={"Motion"}
                      xAxisTitleText={"Location"}
                      yAxisTitleText={"Motion Count"}
                      baseLine={
                        enabled ? motionTrafficVsLocationBaselineValues : {}
                      }
                      setSelectedLocation={setSelectedLocation}
                      setActiveKey={setActiveKey}
                      fileName={generateFilenameWithTimestamp(
                        "Motion Traffic (Last Day)"
                      )}
                      chartName={"Motion Traffic (Last Day)"}
                      isNavigationActive={true}
                    />
                  </CustomSpinnerComponent>
                ),
                id: "Location",
                title: "Motion vs Location",
              },
              {
                content: (
                  <CustomSpinnerComponent
                    height={"400px"}
                    width={"100%"}
                    isLoading={isLoadingMotionTrafficData || isRefreshed}
                  >
                    <TabularFilterComponent
                      selectedValue={selectedLocation}
                      options={assetDisplayLevelsByBlock}
                      onChangeHandler={onChangeHandler}
                      placeHolder={responsivePlaceholder}
                      style={tabularFilterStyle}
                    />
                    <CustomHighChartComponent
                      xAxisCategories={motionCountVsSensorData?.xAxisValues}
                      SeriesType={"column"}
                      seriesData={motionCountVsSensorData?.yAxisMotionCount}
                      seriesShowInLegend={false}
                      seriesName={"Motion"}
                      xAxisTitleText={"Sensors"}
                      yAxisTitleText={"Motion Count"}
                      colors={["#66b2ff"]}
                      extraData={motionCountVsSensorData?.extraData}
                      redirectRoute="/asset/"
                      baseLine={
                        enabled ? motionTrafficVsSensorBaselineValues : {}
                      }
                      yAxisMin={yAxisMinSensor}
                      yAxisMax={yAxisMaxSensor}
                      setSelectedLocation={setSelectedLocation}
                      setActiveKey={setActiveKey}
                      fileName={generateFilenameWithTimestamp(
                        "Motion Traffic (Last Day)"
                      )}
                      chartName={"Motion Traffic (Last Day)"}
                      tooltipFormatter={
                        motionTrafficTooltipFormatterForMotionVsSensor
                      }
                    />
                  </CustomSpinnerComponent>
                ),
                id: "Sensor",
                title: "Motion vs Sensor",
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default MotionTrafficChart;
